export type TextStyle = {
  fontWeight: string;
  label: string;
  level: number;
  meta?: string;
};

export const DEFAULT_TEXT_STYLE_OPTIONS: TextStyle[] = [
  {
    fontWeight: 'bold',
    label: 'Heading XXL',
    level: 1,
  },
  {
    fontWeight: 'bold',
    label: 'Heading XL',
    level: 2,
  },
  {
    fontWeight: 'bold',
    label: 'Heading L',
    level: 3,
  },
  {
    fontWeight: 'bold',
    label: 'Heading M',
    level: 4,
  },
  {
    fontWeight: 'normal',
    label: 'Paragraph L',
    level: 5,
  },
  {
    fontWeight: 'normal',
    label: 'Paragraph M',
    level: 6,
  },
  {
    fontWeight: 'normal',
    label: 'Paragraph S',
    level: 0,
  },
];
